/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { Modality } from "pages/Modality";
import { SimulatorFinance } from "pages/SimulatorFinance";
import { BrowserRouter, Switch } from "react-router-dom";
import { CustomRoute } from "./CustomRoute";
import { Home } from "pages/Home";
import { SimulatorCredit } from "pages/SimulatorCredit";
import { ComercialTaxas } from "pages/SimulatorFinance/ComercialTaxas";
import { LoteTaxas } from "pages/SimulatorFinance/LoteTaxas";

export function Router() {
  return (
    <BrowserRouter>
      <Switch>
        <CustomRoute path="/" exact component={Home} hasLayout={false} />
        <CustomRoute path="/modalidade" exact component={Modality} />

        <CustomRoute path="/financiamento" exact component={SimulatorFinance} />
        <CustomRoute
          path="/financiamento/comercial"
          exact
          component={ComercialTaxas}
        />
        <CustomRoute path="/financiamento/lote" exact component={LoteTaxas} />

        <CustomRoute
          path="/credito-com-imovel"
          exact
          component={SimulatorCredit}
        />
      </Switch>
    </BrowserRouter>
  );
}
